
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.313 2.491a1.913 1.913 0 012.677 0l.005.005L9.3 4.806a1.907 1.907 0 010 2.671l-.432-.425.425.432a.68.68 0 000 .968l.003.003 3.633 3.639a.702.702 0 00.981-.002l.424.433-.425-.432a1.901 1.901 0 012.667 0l.002.001 2.315 2.294.007.007a1.919 1.919 0 010 2.681l-.01.01-.541.53a4.47 4.47 0 01-5.604.614l.328-.51-.339.503a35.704 35.704 0 01-9.567-9.556l-.007-.012a4.484 4.484 0 01.612-5.611l.53-.543.01-.01zm9.095 14.722a3.256 3.256 0 004.083-.453l.007-.008.54-.528a.704.704 0 000-.977l-2.31-2.289a.69.69 0 00-.969 0l-.424-.433.423.434a1.914 1.914 0 01-2.677 0l-.005-.004-3.634-3.64.002.002.425-.433-.429.43.002.001a1.894 1.894 0 01-.003-2.691.692.692 0 000-.966l-2.298-2.3a.702.702 0 00-.977-.003l-.528.54-.007.009a3.267 3.267 0 00-.454 4.088 34.492 34.492 0 009.233 9.221z","fill":"currentColor"}})])
          )
        }
      }
    